let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f36K7")).then(() => parcelRequire('caEBr'));